import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { CardProps, Flex, Spin } from "antd";

import { AuthLogo } from "@components/Auth/Logo";
import { AuthTheme } from "@components/Auth/Theme";

import { StyledCard } from "./styles";

type AuthCardProps = CardProps & {
  showLogo?: boolean;
  loading?: boolean;
};

export const AuthCard = ({
  showLogo,
  loading,
  children,
  ...props
}: AuthCardProps) => {
  return (
    <AuthTheme>
      <StyledCard {...props}>
        <Flex vertical gap={24}>
          {showLogo && <AuthLogo />}

          {loading && (
            <Flex align="center" justify="center" style={{ height: 100 }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} />} />
            </Flex>
          )}

          {!loading && <div>{children}</div>}
        </Flex>
      </StyledCard>
    </AuthTheme>
  );
};
